import { render, staticRenderFns } from "./product-thumb.vue?vue&type=template&id=2f5a8aed&"
import script from "./product-thumb.vue?vue&type=script&lang=js&"
export * from "./product-thumb.vue?vue&type=script&lang=js&"
import style0 from "./product-thumb.vue?vue&type=style&index=0&id=2f5a8aed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports